<template>
  <!-- <el-dialog :title="$t('StorageOutKu.OutDetailed')" :visible.sync="shows" top="70px" height="700px" width="840px" lock-scroll append-to-body @close="close"> -->
  <el-drawer :title="$t('StorageOutKu.title')" :visible.sync="shows" direction="rtl" size="1000" @close="close">
    <div class="_info">
      <div class="detail_info">
        <p class="title">{{ $t('StorageOutKu.detailed') }}</p>
        <div class="content">
          <el-skeleton :rows="6" :loading="DataState == true" animated>
            <div class="content_item">
              <p>
                <span>{{ $t('StorageOutKu.OutKuDanCode') }}:</span> <!-- 出库编号-->
                <font>{{ model.OutKuDanCode }}</font>
              </p>
              <p>
                <span>{{ $t('StorageOutKu.OutKuUserName') }}:</span><!-- 领用人-->
                <font v-if="$getBytes(model.OutKuUserName) < 40">{{ model.OutKuUserName }}</font>
                <el-popover v-else placement="top-start" width="200" trigger="hover" :content="model.OutKuUserName">
                  <font slot="reference">{{ model.OutKuUserName }}</font>
                </el-popover>
              </p>
            </div>
            <div class="content_item">
              <p>
                <span>{{ $t('StorageOutKu.WarehouseName') }}:</span><!-- 库房名称-->
                <font v-if="$getBytes(model.WarehouseName) < 40">{{ model.WarehouseName }}</font>
                <el-popover v-else placement="top-start" width="200" trigger="hover" :content="model.WarehouseName">
                  <font slot="reference">{{ model.WarehouseName }}</font>
                </el-popover>
              </p>
              <p>
                <span>{{ $t('StorageOutKu.Operator') }}:</span><!-- 经办管理员-->
                <font v-if="$getBytes(model.Operator) < 40">{{ model.Operator }}</font>
                <el-popover v-else placement="top-start" width="200" trigger="hover" :content="model.Operator">
                  <font slot="reference">{{ model.Operator }}</font>
                </el-popover>
              </p>
            </div>
            <div class="content_item">
              <p>
                <span>{{ $t('StorageOutKu.OutKuDeptName') }}:</span><!-- 领用部门-->
                <font v-if="$getBytes(model.OutKuDeptName) < 40">{{ model.OutKuDeptName }}</font>
                <el-popover v-else placement="top-start" width="200" trigger="hover" :content="model.OutKuDeptName">
                  <font slot="reference">{{ model.OutKuDeptName }}</font>
                </el-popover>
              </p>
              <p>
                <span>{{ $t('StorageOutKu.OutKuStatus') }}:</span><!-- 出库状态 -->
                <font :style="`color:${model.OutKuStatusColor}`">{{ model.OutKuStatusName }}</font>
              </p>
            </div>
            <div class="content_item">
              <p>
                <span>{{ $t('StorageOutKu.OutKuTime') }}:</span><!-- 出库时间-->
                <font>{{ model.OutKuTime }}</font>
              </p>
              <p>
                <span>{{ $t('StorageOutKu.CreateTimeText') }}:</span><!-- 出库时间-->
                <font>{{ model.CreateTime }}</font>
              </p>
            </div>
            <div class="content_item">
              <p>
                <span>{{ $t('StorageOutKu.OutKuRemark') }}:</span><!-- 出库描述 -->
                <font v-if="$getBytes(model.OutKuRemark) < 40">{{ model.OutKuRemark }}</font>
                <el-popover v-else placement="top-start" width="200" trigger="hover" :content="model.OutKuRemark">
                  <font slot="reference">{{ model.OutKuRemark }}</font>
                </el-popover>
              </p>

            </div>
          </el-skeleton>
        </div>
      </div>
      <div class="Download">

        <div style="float: right">
          <span style="color: #3260f6;cursor: pointer;" @click="OutPrint('StorageOutKu')">{{$t('BasicHome.ExportTemplate')}}</span>
          <el-tooltip class="item" effect="dark" :content="$t('BasicHome.TemplateEditing')" placement="top">
            <i style="color: #3260f6;cursor: pointer;margin-right: 20px;" class="el-icon-edit" @click="getPrintData('StorageOutKu')"></i>
          </el-tooltip>
          <a :href="downUrl" style="color: #3260f6;cursor: pointer;"><i class="el-icon-download"></i> {{
            $t('StorageOutKu.DownloadDetails') }}</a> <!--下载明细-->
          <span class="Refresh"><i class="el-icon-setting" @click="TableOk = true" style="color:#165dff;cursor: pointer;">
              {{ $t('BasicDept.CustomizeHeader') }}</i> </span> <!--自定义表头-->
        </div>
        <div>

          <span style="font-size: 14px">{{ $t('StorageOutKu.MaterialDetails') }}</span> <!--物资明细单-->

        </div>
      </div>
      <el-table border v-loading="loading" :data="list" :height="approveList.length ? '200px' : 'calc(100vh - 440px)'" @header-dragend="headerDragend">
        <el-table-column type="index" width="55" :label="$t('StorageOutKu.NumBer')"> </el-table-column>
        <el-table-column :sortable="item.sort" v-for="(item, index) in GoodsTable" :key="index" :prop="item.propName" :label="item.labelName" :width="item.width">
          <template slot-scope="scope">
            <ImageView v-if="item.propName == 'HuoPinImage'" :url="scope.row.HuoPinImage"></ImageView>
            <span v-else>
              {{ scope.row[item.propName] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="height: 50px; padding-top: 10px" v-if="loading == false">
        <el-col :span="20" class="table_Price">
          {{ $t('StorageInKu.Count') }}{{ OutKuNumber }} {{ $t('StorageInKu.SumMoney') }}{{ OutKuAllPrice }}
        </el-col>
      </el-row>
      <div v-if="approveList.length>0" style="position: relative;width: 100%;height: calc(100vh - 685px);min-height: 180px;">
        <el-table style="position: absolute;min-height: 180px;" border :data="approveList" row-key="ApproverUserName" height="calc(100vh - 685px)" stripe
          :tree-props="{children: 'detailList', hasChildren: 'hasChildren'}">
          <el-table-column :label="$t('Approve.ApprovalSteps')" prop="ApprovalSteps" min-width="120px">
          </el-table-column>
          <el-table-column :label="$t('Approve.ApproverUserName')" prop="ApproverUserName" min-width="120px">
          </el-table-column>
          <el-table-column :label="$t('Approve.ApprovalMethod')" prop="Title" min-width="120px">
          </el-table-column>
          <el-table-column :label="$t('Approve.ApproverStatusName')" prop="ApproverStatusName" min-width="120px">
            <template slot-scope="scope">
              <span :style="`color:${scope.row.PublicFormFontColor};background-color:${scope.row.PublicFormBgColor}`" class="_span_icon">{{ scope.row.ApprovalStatusName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Approve.ApproverType')" prop="TodolistTypeName" min-width="120px">
          </el-table-column>
          <el-table-column :label="$t('Approve.ApproverTimeText')" prop="ApprovalTimeText" min-width="120px">
          </el-table-column>
        </el-table>
      </div>
      <div v-if="approveType" class="_operate_btn">
        <el-popconfirm :title="$t('Approve.RejectTips')" @confirm="operate(3)">
          <el-button slot="reference" icon="el-icon-close" class="button_waring">{{
            $t('Approve.Reject')
          }}</el-button>
        </el-popconfirm>
        <el-popconfirm :title="$t('Approve.AgreeTips')" @confirm="operate(1)">
          <el-button slot="reference" icon="el-icon-check" style="margin-left: 20px;" class="button_primary">{{
            $t('Approve.Agree')
          }}</el-button>
        </el-popconfirm>
      </div>
    </div>
    <DragTable v-if="TableOk" TableName="StorageOutKuDetail" :show="TableOk" @message="Message_">
    </DragTable>
  </el-drawer>
</template>

<script>
import {
  LoadBasicUserColumn,
  SetBasicUserColumnWidth

} from "@/api/user";
import outprint from '@/mixins/outprint'
import emitapprove from "@/mixins/emitapprove";
export default {
  mixins: [emitapprove, outprint],
  props: {
    approveType: {
      type: Boolean,
      default: false
    },
    approveList: {
      type: Array,
      default() {
        return []
      }
    },
    form: {
      type: Object
    },
    Notes: {
      type: Array,
      default() {
        return []
      }
    },
    show: {
      type: Boolean
    }
  },
  computed: {
    OutKuNumber() {
      let sum = 0;
      for (let i = 0; i < this.list.length; i++) {
        sum = parseInt(this.list[i].OutKuCount || 0) + parseInt(sum);
      }
      return sum || 0;
    },
    OutKuAllPrice() {
      let sum = 0;
      for (let i = 0; i < this.list.length; i++) {
        sum = parseFloat(parseFloat(sum) + parseFloat(this.list[i].AllPrice)).toFixed(2);
      }
      return sum || 0;
    },
  },
  data() {
    return {
      downUrl: '',
      model: {},
      list: [],
      GoodsTable: [],
      TableOk: false,
      DataState: true,
      loading: false,
      shows: false
    }
  },

  mounted() {
    this.model = this.form;
    for (let item in this.model) {
      if (item.toUpperCase().includes('TIME')) {
        this.model[item] = this.$transferTime(this.model[item]);
      }
    }
    this.loading = true;
    let lang = localStorage.getItem("locale") || "zh_CN";
    this.downUrl = this.$url + '/StorageOutKuDan/OutKuDownExcel?code=' + this.form.OutKuDanID + '&UserID=' + this.$store.state.userinfo.UserID + '&Language=' + lang;
    setTimeout(() => {
      this.list = this.Notes;
      if (this.model) {
        this.DataState = false;
      } else {
        this.DataState = false;
      }
      this.loading = false;
    }, 1000)
    this.shows = this.show;
    this.getTableColumn();
  },
  methods: {
    // 表头拖动事件
    headerDragend(newWidth, data, e) {
      data
      if (e.property != null) {
        SetBasicUserColumnWidth({ TableKey: 'StorageOutKuDetail', ColumnKey: e.property, Width: newWidth }).then(res => {
          if (res.Code == 0) {
            res
          }
        })
      }
    },
    // 表单加载
    getTableColumn() {
      LoadBasicUserColumn({ TableKey: 'StorageOutKuDetail' }).then(res => {
        if (res.Code == 0) {
          this.GoodsTable = res.Data;
        }
      })
    },
    //刷新
    Message_(e) {
      if (e == 0) {
        this.getTableColumn();
      }
      this.TableOk = false;
      this.list = [];

      setTimeout(() => {
        this.list = this.Notes;
      }, 500)
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_info .content .content_item {
  height: 30px !important;
}

/deep/ .content_item {
  height: 30px !important;
}

span.Refresh {
  margin-left: 15px;
}

.el-dialog__title {
  font-size: 16px;
  color: #1d2129;
}

span.el-dialog__title {
  margin-left: 8px;
}

.content_item {
  margin-top: 12px;
}

.el-dialog__body {
  padding: 0px 32px;
}

.Download {
  margin-bottom: 17px;
}

.detail_info {
  margin-bottom: 25px;
}

.textarea {
  width: 75%;
}

a {
  text-decoration: none;
  color: #409eff;
}

/deep/.el-drawer {
  width: 1000px;
}
</style>